// src/components/branding/PoweredBy.tsx
import React from 'react';

import { useBranding } from '../../context/BrandingContext';

export interface PoweredByProps {
	className?: string;
	style?: React.CSSProperties;
}

const PoweredBy: React.FC<PoweredByProps> = ({ className, style }) => {
	const { branding, isResolved } = useBranding();

	if (!isResolved || !branding.whitelabel) return null;

	return (
		<span
			className={className}
			data-testid="powered-by"
			style={{
				color: 'var(--mg-text-secondary)',
				fontSize: 'var(--mg-fs-xs)',
				lineHeight: 1.4,
				whiteSpace: 'nowrap',
				...style,
			}}
		>
			Powered by {branding.powered_by}
		</span>
	);
};

export default PoweredBy;
